import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaPhp,
  FaGitSquare,
  FaBootstrap,
  FaResolving,
  FaDocker,
} from 'react-icons/fa';
import {
  SiRuby,
  SiRubyonrails,
  SiJquery,
  SiPostgresql,
  SiMysql,
  SiNestjs,
  SiNextdotjs,
  SiGo,
  SiReactivex,
  SiTypescript,
  SiNodedotjs,
  SiKubernetes,
  SiMongodb,
  SiMicrosoftsqlserver,
  SiTerraform,
  SiAnsible,
  SiPrometheus,
  SiGrafana,
  SiHelm,
  SiJenkins,
  SiIstio,
  SiNginx,
  SiLinux,
  SiEtcd,
} from 'react-icons/si';
import { GiTeamIdea, GiSatelliteCommunication } from 'react-icons/gi';
import { RiComputerFill } from 'react-icons/ri';

const skillList = {
  Frontend: [
    {
      name: 'HTML5',
      icon: <FaHtml5 className="skill-icon" />,
    },
    {
      name: 'CSS3',
      icon: <FaCss3Alt className="skill-icon" />,
    },
    {
      name: 'JavaScript',
      icon: <FaJs className="skill-icon" />,
    },
    {
      name: 'TypeScript',
      icon: <SiTypescript className="skill-icon" />,
    },
    {
      name: 'React',
      icon: <FaReact className="skill-icon" />,
    },
    {
      name: 'Next.js',
      icon: <SiNextdotjs className="skill-icon" />,
    },
    {
      name: 'JQuery',
      icon: <SiJquery className="skill-icon" />,
    },
    {
      name: 'Bootstrap',
      icon: <FaBootstrap className="skill-icon" />,
    },
  ],
  Backend: [
    {
      name: 'NodeJS',
      icon: <SiNodedotjs className="skill-icon" />,
    },
    {
      name: 'NestJS',
      icon: <SiNestjs className="skill-icon" />,
    },
    {
      name: 'Ruby on Rails',
      icon: <SiRubyonrails className="skill-icon" />,
    },
    {
      name: 'Ruby',
      icon: <SiRuby className="skill-icon" />,
    },
    {
      name: 'PHP',
      icon: <FaPhp className="skill-icon" />,
    },
    {
      name: 'Golang',
      icon: <SiGo className="skill-icon" />,
    },
    {
      name: 'Git',
      icon: <FaGitSquare className="skill-icon" />,
    },
  ],
  Database: [
    {
      name: 'PostgreSQL',
      icon: <SiPostgresql className="skill-icon" />,
    },
    {
      name: 'MySQL',
      icon: <SiMysql className="skill-icon" />,
    },
    {
      name: 'MSSQL',
      icon: <SiMicrosoftsqlserver className="skill-icon" />,
    },
    {
      name: 'MongoDB',
      icon: <SiMongodb className="skill-icon" />,
    },
  ],
  Mobile: [
    {
      name: 'React Native',
      icon: <SiReactivex className="skill-icon" />,
    },
  ],
  DevOps_and_Cloud: [
    {
      name: 'Docker',
      icon: <FaDocker className="skill-icon" />,
    },
    {
      name: 'Kubernetes',
      icon: <SiKubernetes className="skill-icon" />,
    },
    {
      name: 'Terraform',
      icon: <SiTerraform className="skill-icon" />,
    },
    {
      name: 'Ansible',
      icon: <SiAnsible className="skill-icon" />,
    },
    {
      name: 'Helm',
      icon: <SiHelm className="skill-icon" />,
    },
    {
      name: 'ArgoCD',
      icon: <SiKubernetes className="skill-icon" />,
    },
    {
      name: 'Tekton',
      icon: <SiKubernetes className="skill-icon" />,
    },
    {
      name: 'Jenkins',
      icon: <SiJenkins className="skill-icon" />,
    },
    {
      name: 'Istio',
      icon: <SiIstio className="skill-icon" />,
    },
    {
      name: 'Calico CNI',
      icon: <SiKubernetes className="skill-icon" />,
    },
    {
      name: 'Prometheus',
      icon: <SiPrometheus className="skill-icon" />,
    },
    {
      name: 'Grafana',
      icon: <SiGrafana className="skill-icon" />,
    },
    {
      name: 'Nginx Ingress',
      icon: <SiNginx className="skill-icon" />,
    },
    {
      name: 'etcd',
      icon: <SiEtcd className="skill-icon" />,
    },
    {
      name: 'Linux',
      icon: <SiLinux className="skill-icon" />,
    },
  ],
  Soft_Skills: [
    {
      name: 'Problem Solving',
      icon: <FaResolving className="skill-icon" />,
    },
    {
      name: 'Teamwork',
      icon: <GiTeamIdea className="skill-icon" />,
    },
    {
      name: 'Pair Programming',
      icon: <RiComputerFill className="skill-icon" />,
    },
    {
      name: 'Communication',
      icon: <GiSatelliteCommunication className="skill-icon" />,
    },
  ],
};

export const resumeData = [
  {
    title: 'Senior Specialist, DevOps',
    company: 'Development Bank of Rwanda',
    date: 'Jan 2025 - Present',
    responsibilities: [
      'Architect and automate scalable Kubernetes platforms using Kubespray and Terraform.',
      'Build and manage GitOps-driven CI/CD pipelines with ArgoCD, Tekton, and Jenkins.',
      'Implement Calico for network policy, security, and cluster connectivity optimization.',
      'Automate infrastructure and operations with Ansible, Python, and Bash.',
      'Enhance observability with Prometheus, Grafana, and ELK/EFK for proactive monitoring.',
      'Integrate DevSecOps practices — RBAC, secrets management, and compliance automation.',
      'Collaborate with developers to streamline releases and improve system reliability.',
      'Optimize platform performance, scalability, and cost efficiency across environments.',
    ],
  },
  {
    title: 'Software Engineer - Consultant',
    company: 'Ossix Technologies, LLC',
    date: 'Oct 2024 - Jan 2025',
    description: `
      Developed and optimized a central payment gateway using NestJS.
      Integrated third-party fintech APIs for secure, scalable, and seamless transaction processing.
      Designed and implemented solutions to handle high transaction volumes with efficiency.
      Collaborated with cross-functional teams to align solutions with business goals.
      Continuously improved architecture and workflows based on fintech trends.
    `,
  },
  {
    title: 'DevOps Engineer',
    company: 'Development Bank of Rwanda',
    date: 'Jan 2024 - Sep 2025',
    description: `
      Collaborated with developers and IT staff to manage code releases, fostering a culture of quality and continuous improvement.
      Designed and maintained scalable infrastructure using Terraform and automated provisioning with IaC.
      Managed CI/CD pipelines integrated with testing frameworks for efficient deployments.
      Implemented monitoring, logging, and security best practices while ensuring compliance.
      Optimized cloud infrastructure (AWS, Azure, GCP) for performance and cost.
      Provided DevOps training and collaborated cross-functionally to drive successful product outcomes.
    `,
  },
  {
    title: 'IT Product Developer',
    company: 'Development Bank of Rwanda',
    date: 'Jan 2023 - Dec 2023',
    description: `
      Created a comprehensive digitalization plan using service system design.
      Gathered user requirements and proposed digitization roadmaps for process optimization.
      Conducted market research, client interviews, and MVP testing to validate solutions.
      Integrated multi-channel input into product priorities and requirements.
      Collaborated across teams to launch and evaluate innovative digital products.
    `,
  },
  {
    title: 'Code Reviewer',
    company: 'Microverse',
    date: 'Mar 2022 - Oct 2022',
    responsibilities: [
      'Held 1:1 mentoring sessions for students struggling with Rails/React & Redux, Git, and related tech.',
      'Enforced coding standards and best practices.',
      'Answered student questions and provided guidance.',
      'Checked projects for plagiarism.',
    ],
  },
  {
    title: 'Senior Software Engineer',
    company: 'Kigali Independent University ULK',
    date: 'Feb 2022 - Dec 2022',
    description: `
      Maintained the existing Information Management System.
      Designed requirements for a new MIS as an upgrade to the existing system.
      Collaborated with a development team on implementation.
    `,
  },
  {
    title: 'Student Mentor',
    company: 'Microverse',
    date: 'Dec 2021 - Mar 2022',
    responsibilities: [
      'Mentored junior developers and reviewed code.',
      'Suggested improvements to code structure for better quality and performance.',
      'Provided motivational support for program completion.',
    ],
  },
  {
    title: 'Software Engineer',
    company: 'Events Factory Rwanda',
    date: 'Jan 2018 - Jun 2020',
    responsibilities: [
      'Gathered requirements and proposed a digitization roadmap.',
      'Developed an Event Registration System for managing participants and payments.',
      'Built an Accreditation System for designing and printing badges.',
      'Created an Accommodation System for booking and paying for hotels during events.',
    ],
  },
  {
    title: 'Back End Developer',
    company: 'Connect Interchange',
    date: 'Apr 2019 - Sep 2019',
    description: `
      Developed a digitization plan to enable web portal access for a mentorship program.
    `,
  },
  {
    title: 'Web Developer',
    company: 'kLab',
    date: 'Jul 2017 - Jul 2018',
    responsibilities: [
      'Mentored junior developers and provided code reviews.',
      'Recommended improvements for code organization and performance.',
      'Offered guidance to help maintain motivation in development programs.',
    ],
  },
];

export const educationData = [
  {
    title: 'Software Engineering and Full-Stack Web Development',
    institution: 'Microverse',
    date: '2021 - 2022',
    description: `
      I excel in algorithms, data structures, and full-stack development, 
      collaborating with a group of six different coding partners through remote 
      pair programming each week. Our projects span Ruby, Rails, JavaScript, React, and Redux, 
      and we leverage GitHub, industry-standard git-flow, and daily standups to 
      effectively communicate and collaborate with international remote developers.`,
  },
  {
    title: 'Bachelor in Network and Communication Systems',
    institution: 'Adventist University Of Central Africa',
    date: '2016 - 2022',
    description: `
      Relevant coursework: Computer Architecture, Operative Systems, 
      Database and Information Systems, Introduction to Software Engineering, 
      Mathematical Analysis, Advanced Mathematical Analysis, and Optimization Methods.`,
  },
];

export default skillList;
